function o(o){const t=document.cookie.match("(^|;)\\s*"+o+"\\s*=\\s*([^;]+)");return t?t.pop():""}export{o as getCookie};
